import $ from 'jquery';

let $closeNotificationButton = $('.js-close-question-notification');
const $questionForm = $('.js-question-form');
$questionForm.submit(function (e) {
	e.preventDefault();
	const $form = $(this);

	$.ajax({
		url: '/',
		method: 'POST',
		data: $form.serialize(),
	}).done((response) => {
		$form.html(response.question_content);
		$('#js-question-notification-wrapper').html(
			response.notification_content
		);
		const $questionNotification = $('.question-notification');
		setTimeout(() => $questionNotification.removeClass('hidden'), 0);
		$closeNotificationButton = $('.js-close-question-notification');

		$closeNotificationButton.click((e) => {
			e.preventDefault();
			$questionNotification.addClass('hidden');
			setTimeout(() => $questionNotification[0].remove(), 300);
		});
	});
});
